import { render, staticRenderFns } from "./StudentTaskOf.vue?vue&type=template&id=76b2f59b&scoped=true&"
import script from "./StudentTaskOf.vue?vue&type=script&lang=js&"
export * from "./StudentTaskOf.vue?vue&type=script&lang=js&"
import style0 from "./StudentTaskOf.vue?vue&type=style&index=0&id=76b2f59b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b2f59b",
  null
  
)

export default component.exports